import React from "react"
import { AuthServiceContext } from "services/auth/AuthContext"

export const useAuthService = () => {
    return React.useContext(AuthServiceContext)
}

export const useAuth = () => {
    const { useAuthHook } = useAuthService()
    return useAuthHook()
}
